import React from 'react';
import OldInput from './Input.old';
import NewInput from './Input.new';

type InputType = 'default' | 'currency' | 'number' | 'password';

export type InputProps = {
  name: string;
  label?: string;
  error?: string | boolean;
  inputRef?:
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>;
  style?: React.CSSProperties;
  defaultValue?: string;
  value?: string;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
  autoFocus?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  type?: InputType;
  currency?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  textColor?: string;
  baseColor?: string;
  mainColor?: string;
  accentColor?: string;
  inactiveColor?: string;
  dangerColor?: string;
  backgroundColor?: string;
  initialIsLabelUp?: boolean;
};

// label is used only in the new input
// so we use it to keep the old input in the pages that
// are not yet updated
function Input(props: InputProps) {
  if (typeof props?.label !== 'undefined') return <NewInput {...props} />;
  return <OldInput {...props} />;
}

export default React.memo(Input);
